import { useGlobalGroupsData } from "@/data/use-global-groups-data";
import { ChipCombobox } from "../ui/chip-combobox";

export function GroupChipCombobox({
  selectedGroupUuids,
  onChange,
  disabled,
}: {
  selectedGroupUuids: string[];
  onChange: (value: string, selected: boolean) => void;
  disabled?: boolean;
}) {
  const { groups } = useGlobalGroupsData();

  return (
    <ChipCombobox
      selected={selectedGroupUuids}
      onSelectionChange={onChange}
      disabled={disabled}
      groups={[
        {
          groupName: "Groups",
          options: groups.map((group) => ({
            searchableText: group.name,
            renderChip: () => group.name,
            renderOption: () => group.name,
            value: group.uuid,
          })),
        },
      ]}
    />
  );
}
